// Long-lived browser device identifier — used for the Trusted Devices
// feature. Generated on first visit and persisted in localStorage so it
// survives sign-outs and tab restarts. NEVER sent inside the URL.
//
// Format: 32 hex chars (16 random bytes). 1.2e38 possible values — collision
// risk is negligible even at billions of devices.
const STORAGE_KEY = "bl_device_id";

function generateDeviceId() {
    // Prefer crypto.randomUUID where available; fall back to bytes-to-hex.
    try {
        if (typeof crypto !== "undefined" && crypto.randomUUID) {
            return crypto.randomUUID().replace(/-/g, "");
        }
        const buf = new Uint8Array(16);
        crypto.getRandomValues(buf);
        return Array.from(buf)
            .map((b) => b.toString(16).padStart(2, "0"))
            .join("");
    } catch {
        // Last-ditch fallback — Math.random-based, weaker but better than nothing.
        let s = "";
        for (let i = 0; i < 32; i += 1) {
            s += Math.floor(Math.random() * 16).toString(16);
        }
        return s;
    }
}

export function getOrCreateDeviceId() {
    try {
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing && /^[a-f0-9]{16,64}$/i.test(existing)) {
            return existing;
        }
        const fresh = generateDeviceId();
        localStorage.setItem(STORAGE_KEY, fresh);
        return fresh;
    } catch {
        // localStorage blocked (incognito Safari, etc.) — fall back to
        // an in-memory id so the rest of the app keeps working.
        if (typeof window !== "undefined") {
            window.__bl_device_id_memcache ||= generateDeviceId();
            return window.__bl_device_id_memcache;
        }
        return generateDeviceId();
    }
}

export function readDeviceId() {
    try {
        return localStorage.getItem(STORAGE_KEY) || null;
    } catch {
        return null;
    }
}
